import axios from "./axios";
import customFetch from "./fetch";

// interfaces
import { SearchLocationsProps, SearchLocationsRequestProps } from "@/types/api/SearchLocation";
import { ISingleLocationResponse } from "@/types/api/SingleLocationResponse";

// helpers
import API_ROUTES from "./routes.constant";
import { pathToUrl } from "./query/reactQuery/pathToUrl";
import { buildUrl } from "./helpers";

export default {
  async searchLocations({ query }: SearchLocationsProps): Promise<SearchLocationsRequestProps> {
    return axios.get(`${API_ROUTES.locationsUrls.quickSearch}?query=${query}`);
  },
  async getLocation(slug: string, params?: Record<string, unknown>) {
    const { preview, ...restParams } = params || {};

    const fetchKey = slug ? pathToUrl(API_ROUTES.locationsUrls.locationsSingle, { slug }) : null;
    const fetchKeyPreview = slug ? pathToUrl(API_ROUTES.previewUrls.previewLocation, { slug }) : null;

    return await customFetch(
      buildUrl((preview ? fetchKeyPreview : fetchKey) as string, restParams),
      {
        headers: {
          "LOCATION-AUTH": preview && `Bearer ${preview}`,
        } as unknown as HeadersInit,
      }
    ) as ISingleLocationResponse;
  },
  async getLocationsRecordPageView(slug: string) {
    const fetchKey = slug ? pathToUrl(API_ROUTES.locationsUrls.locationRecordPageView, { slug }) : null;

    return axios.get(fetchKey || "");
  }
};
